import type { JSX } from "react";

const sizeVariants = {
  sm: "text-sm",
  md: "text-md",
  lg: "text-lg",
  xl: "text-xl",
  "2xl": "text-2xl",
  "3xl": "text-3xl",
};
const baseClassName =
  "cursor inline-flex items-center justify-center rounded-full bg-primary px-4 py-2 text-center text-sm font-semibold text-white shadow-sm transition-all duration-200 ease-out hover:-translate-y-0.5 hover:bg-primary-darker hover:shadow-md active:translate-y-0 active:shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary dark:hover:bg-primary/80";

interface ButtonProps {
  className?: string;
  url: string;
  label: string;
  icon?: JSX.Element;
  size?: keyof typeof sizeVariants;
  dataTinaField?: string;
  labelDataTinaField?: string;
}

export const ButtonPrimary = ({
  url,
  label,
  icon,
  size,
  className,
  dataTinaField,
  labelDataTinaField,
}: ButtonProps) => {
  const classes = [baseClassName, className].filter(Boolean).join(" ");

  return (
    <a href={url} className={classes} data-tina-field={dataTinaField}>
      <span
        className={`${size ? sizeVariants[size] : ""} inline-flex items-center justify-center gap-2 leading-none`}
        data-tina-field={labelDataTinaField}
      >
        {icon}
        {label}
      </span>
    </a>
  );
};
export default ButtonPrimary;
